module.exports = __webpack_public_path__ + "static/media/img-talent-profile-bottom.a475bb53.png";